import {
  GET_LIST_NGUONVON,
  GET_LIST_NGUONVON_SUCCESS,
  GET_LIST_NGUONVON_FAILURE,
  UPDATE_SEARCHTDATA_NGUONVON,
} from "./actionTypes";

export const getListNguonVon = (dataSearch) => ({
  type: GET_LIST_NGUONVON,
  dataSearch,
});
export const getListNguonVonSuccess = (data) => ({
  type: GET_LIST_NGUONVON_SUCCESS,
  payload: data,
});
export const getListNguonVonFailure = (dataSearch) => ({
  type: GET_LIST_NGUONVON_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_NGUONVON,
  payload: data,
});
